import { takeLatest, call, put } from 'redux-saga/effects'
import updateEnrol from 'api/enrols/Edit'
import { IEnrolModel } from 'models/enrol.model'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'
import I18n from 'i18n'
import { EnrolState } from 'enum'
import * as fromActions from '../../actions/enrols.action'

async function editEnrol(data: IEnrolModel) {
  return await updateEnrol(data)
}

export function* EditEnrolEffectSaga(action: any) {
  try {
    const { data } = yield call(editEnrol, action.payload)
    yield put(fromActions.Actions.enrolEditSuccess(data))
    yield put(fromActions.Actions.enrolAdminListReload())

    SuccessToast(
      I18n.t(
        `administration.toastMessages.${
          data.stateAdmin === EnrolState.Approved
            ? 'requestApproved'
            : 'requestDenied'
        }`
      )
    )
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.genericError'))
    console.log('error: ', error)
  }
}

export function* editEnrolWatcherSaga() {
  yield takeLatest(fromActions.ENROL_EDIT, EditEnrolEffectSaga)
}
